import * as React from "react";
import { makeStyles, mergeClasses } from "@fluentui/react-components";
/**
 * Function which returns a hook for styling icons.
 */ const useBaseIconStyles = makeStyles({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
});
/**
 * Utility to wrap a FluentIcon with base styles
 * @param IconComponent - The fluent icon component to be styled
 * @returns FluentIcon - The fluent icon component with added base styles
 */ export const wrapIconWithStyles = (IconComponent, baseProps)=>{
    /**
     * A FluentIcon with added base styles and size.
     * It also exposes props to override these base styles if needed.
     * @param props FluentIconProps for the component
     * @returns {React.FC<FluentIconsProps>} renders a FluentIcon react component
     */ const StyledFluentIcon = (props)=>{
        const classNames = useBaseIconStyles();
        const className = mergeClasses(classNames.root, props.className);
        // set default font size (icon size) to 20px/1.5em
        const baseFontSize = baseProps?.fontSize ?? "20px";
        const mergedProps = {
            fontSize: baseFontSize,
            ...baseProps,
            ...props
        };
        return /*#__PURE__*/ React.createElement(IconComponent, {
            className: className,
            ...mergedProps
        });
    };
    return StyledFluentIcon;
};
